export const OPTIONS_INJURY_AGENT = [
  { value: "1", label: "Máquina y/o equipos" },
  { value: "2", label: "Medios de transporte" },
  { value: "3", label: "Aparatos" },
  { value: "4", label: "Herramientas, implementos o utensilios" },
  { value: "5", label: "Materiales o sustancias" },
  { value: "6", label: "Ambiente de trabajo" },
  { value: "7", label: "Otros agentes no clasificados" },
  { value: "8", label: "Animales (vivos o productos animales)" },
  { value: "9", label: "Agentes no clasificados por falta de datos" },
];

export const OPTIONS_BEHAVIOR_OR_CONDITION = [
  { value: "1", label: "Comportamiento" },
  { value: "2", label: "Condición" },
];

export const OPTIONS_INCIDENT_MECHANISM = [
  { value: "1", label: "Caída de personas" },
  { value: "2", label: "Caída de objetos" },
  { value: "3", label: "Pisadas, choques o golpes" },
  { value: "4", label: "Atrapamiento" },
  { value: "5", label: "Sobreesfuerzo, esfuerzo excesivo o falso movimiento" },
  { value: "6", label: "Exposición o contacto con temperatura extrema" },
  { value: "7", label: "Exposición o contacto con la electricidad" },
  {
    value: "8",
    label:
      "Exposición o contacto con sustancias nocivas, radiaciones o salpicaduras",
  },
  { value: "9", label: "Golpes por o contra objetos" },
  { value: "10", label: "Otros" },
];

export const OPTIONS_INJURY_TYPE = [
  { value: "1", label: "Ninguna" },
  { value: "2", label: "Leve" },
  { value: "3", label: "Grave" },
  { value: "4", label: "Moderado" },
];

export const OPTIONS_AFFECTED_BODY_PART = [
  { value: "1", label: "Cabeza" },
  { value: "2", label: "Ojos" },
  { value: "3", label: "Cuello" },
  {
    value: "4",
    label:
      "Tronco (Incluye espalda, columna vertebral, médula espinal y pelvis)",
  },
  { value: "5", label: "Tórax" },
  { value: "6", label: "Abdomen" },
  { value: "7", label: "Miembros superiores" },
  { value: "8", label: "Miembros inferiores" },
  { value: "9", label: "Manos" },
  { value: "10", label: "Pies" },
  { value: "11", label: "Ubicaciones múltiples" },
  { value: "12", label: "Lesiones generales u otras" },
];
